<template>
  <div>
    <b-button
      class="mb-3"
      variant="warning"
      @click="toBack"
    >
      {{$t('modal.button.back')}}
    </b-button>
    <b-card>
      <b-table
        :fields="fields"
        :items="items"
      >
        <template #cell(pivot)="{item}">
          <b-button
            v-if="item.pivot.direction === 0"
            variant="primary"
            size="sm"
          >
            <i class='bx bxs-truck fs-4'></i>
            <i class="bx bx-right-arrow-alt fs-4"></i>
          </b-button>

          <b-button
            v-if="item.pivot.direction === 1"
            variant="success"
            size="sm"
          >
            <i class="bx bx-left-arrow-alt fs-4"></i>
            <i class='bx bxs-truck bx-flip-horizontal fs-4' ></i>
          </b-button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
  import {showDriverWaterRound} from '../../../../api/endpoints/driverWaterRounds'

  export default {
    name: "DriverWaterRounds-Products",
    data() {
      return {
        id: null,
        fields: [
          {key: "id", label: "№"},
          {key: "name", label: this.$t('table.name.label')},
          {key: "pivot.quantity", label: this.$t('table.get_set_count.label')},
          {key: "pivot", label: this.$t('table.direction')},
        ],
        items: []
      }
    },
    methods: {
      toBack() {
        this.$router.push("/driver/water-rounds")
      },
      fetchData() {
        showDriverWaterRound(this.$route.params.id).then( response => {
          this.items = response.data.products
        })
      }
    },
    created() {
      this.fetchData();
    }
  }
</script>